(function() {
    let currentImage = 0;
    let isTransitioning = false;
    let pendingImageIndex = null;
    let imageLoadGeneration = 0;

    function getMedia() {
        return window.allProductMedia || window.allProductImages || [];
    }

    function changeMedia(index) {
        // Get all thumbnails (support both new and old HTML structure)
        const thumbs = document.querySelectorAll('.ergonix-wrapper .thumbnails-container .thumbnail, .ergonix-wrapper .thumbnail-image');
        const totalCount = thumbs.length || getMedia().length;
        if (index < 0 || index >= totalCount) return;

        if (isTransitioning) {
            pendingImageIndex = index;
            return;
        }

        isTransitioning = true;
        currentImage = index;
        pendingImageIndex = null;

        const mainImage = document.getElementById('mainImage');
        const mainVideo = document.getElementById('mainVideo');
        const muteBtn = document.getElementById('desktopMuteBtn');

        // Determine if this is a video slide
        // Check thumbnail data-media-type first (new HTML), then media array (fallback)
        const thumb = thumbs[index];
        const mediaType = thumb ? thumb.getAttribute('data-media-type') : null;
        const videoSrc = thumb ? thumb.getAttribute('data-video-src') : null;
        const media = getMedia();
        const mediaItem = media[index];
        const isVideo = mediaType === 'video' || (mediaItem && (mediaItem.type === 'video' || mediaItem.videoSrc));
        const resolvedVideoSrc = videoSrc || (mediaItem && mediaItem.videoSrc);

        if (isVideo && resolvedVideoSrc) {
            // Show video, hide image
            if (mainImage) mainImage.style.display = 'none';
            if (mainVideo) {
                mainVideo.src = resolvedVideoSrc;
                mainVideo.style.display = 'block';
                mainVideo.currentTime = 0;
                mainVideo.play().catch(() => {});
            }
            if (muteBtn) muteBtn.style.display = 'flex';
            isTransitioning = false;
            if (pendingImageIndex !== null) {
                const next = pendingImageIndex;
                pendingImageIndex = null;
                changeMedia(next);
            }
        } else {
            // Show image, hide video
            if (mainVideo && mainVideo.src) {
                mainVideo.pause();
                mainVideo.style.display = 'none';
                mainVideo.removeAttribute('src');
                mainVideo.load();
            } else if (mainVideo) {
                mainVideo.style.display = 'none';
            }
            if (muteBtn) muteBtn.style.display = 'none';

            // PRIMARY: get image URL from the thumbnail's data-full-image attribute
            // This is the most reliable source since thumbnails match 1:1 with their index
            let fullUrl = thumb ? thumb.getAttribute('data-full-image') : null;
            // FALLBACK: try the media array
            if (!fullUrl && mediaItem) {
                fullUrl = mediaItem.src;
            }

            if (mainImage && fullUrl) {
                mainImage.style.display = 'block';
                imageLoadGeneration++;
                const gen = imageLoadGeneration;

                // Compare without protocol prefix to handle //url vs https://url
                const currentSrc = mainImage.src.replace(/^https?:/, '');
                const newSrc = fullUrl.replace(/^https?:/, '');

                if (currentSrc !== newSrc) {
                    const img = new Image();
                    img.onload = img.onerror = () => {
                        if (gen === imageLoadGeneration) {
                            mainImage.src = fullUrl;
                        }
                        isTransitioning = false;
                        if (pendingImageIndex !== null) {
                            const next = pendingImageIndex;
                            pendingImageIndex = null;
                            changeMedia(next);
                        }
                    };
                    img.src = fullUrl;
                } else {
                    isTransitioning = false;
                    if (pendingImageIndex !== null) {
                        const next = pendingImageIndex;
                        pendingImageIndex = null;
                        changeMedia(next);
                    }
                }
            } else {
                if (mainImage) mainImage.style.display = 'block';
                isTransitioning = false;
            }
        }

        updateThumbnails();
    }

    // Backward compat
    function changeImage(index) {
        changeMedia(index);
    }

    function toggleMute(event) {
        if (event) event.stopPropagation();
        const video = document.getElementById('mainVideo');
        if (!video) return;

        video.muted = !video.muted;

        const btn = document.getElementById('desktopMuteBtn');
        if (btn) {
            const volIcon = btn.querySelector('.icon-vol');
            const mutedIcon = btn.querySelector('.icon-muted');
            if (volIcon) volIcon.style.display = video.muted ? 'none' : 'inline';
            if (mutedIcon) mutedIcon.style.display = video.muted ? 'inline' : 'none';
        }
    }

    function previousImage() {
        if (currentImage > 0) {
            changeMedia(currentImage - 1);
        }
    }

    function nextImage() {
        const thumbs = document.querySelectorAll('.ergonix-wrapper .thumbnails-container .thumbnail, .ergonix-wrapper .thumbnail-image');
        const totalCount = thumbs.length || getMedia().length;
        if (currentImage < totalCount - 1) {
            changeMedia(currentImage + 1);
        }
    }

    function updateThumbnails() {
        // Support both new (.thumbnail) and old (.thumbnail-image) selectors
        let thumbs = document.querySelectorAll('.ergonix-wrapper .thumbnails-container .thumbnail');
        if (thumbs.length === 0) {
            thumbs = document.querySelectorAll('.ergonix-wrapper .thumbnail-image');
        }
        thumbs.forEach((thumb, index) => {
            thumb.classList.toggle('active', index === currentImage);
        });

        // Also update video thumbnail if old structure
        const videoThumb = document.querySelector('.ergonix-wrapper .thumbnail-video');
        if (videoThumb) videoThumb.classList.remove('active');

        // Scroll active thumbnail into view
        if (thumbs[currentImage]) {
            thumbs[currentImage].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        // Update navigation buttons
        const media = getMedia();
        const totalCount = Math.max(media.length, thumbs.length);
        const prevBtn = document.querySelector('.ergonix-wrapper .image-nav:first-child');
        const nextBtn = document.querySelector('.ergonix-wrapper .image-nav:last-child');

        if (prevBtn) {
            prevBtn.classList.toggle('disabled', currentImage === 0);
        }
        if (nextBtn) {
            nextBtn.classList.toggle('disabled', currentImage === totalCount - 1);
        }
    }

    // Color translations via locale strings from layout
    const colorTranslations = window.cartStrings ? {
        'Grey': window.cartStrings.colorGrey || 'Grey',
        'Gray': window.cartStrings.colorGrey || 'Grey',
        'Black': window.cartStrings.colorBlack || 'Black',
        'Szary': window.cartStrings.colorGrey || 'Grey',
        'Czarny': window.cartStrings.colorBlack || 'Black',
        'Pilka': window.cartStrings.colorGrey || 'Grey',
        'Juoda': window.cartStrings.colorBlack || 'Black'
    } : { 'Grey': 'Grey', 'Gray': 'Grey', 'Black': 'Black' };

    function translateColorToLithuanian(color) {
        return colorTranslations[color] || color;
    }

    function selectColor(color) {
        // Translate and update label
        const colorLabel = document.querySelector('.ergonix-wrapper .color-label strong');
        if (colorLabel) {
            colorLabel.textContent = translateColorToLithuanian(color);
        }

        // NEW: Variant mapping (will be populated dynamically)
        const variantMap = window.productVariants || {
            'Black': '52380192702797',
            'Grey': '52380192735565'
        };

        const variantId = variantMap[color];

        // Update hidden form input
        const input = document.getElementById('variant-id-input');
        if (input) {
            input.value = variantId;
        }

        // Update global state
        window.currentSelectedVariant = variantId;

        // Update price display
        if (window.cart && window.cart.updatePriceDisplay) {
            window.cart.updatePriceDisplay(variantId);
        }

        // Update desktop sticky cart (like mobile does)
        if (typeof updateDesktopStickyCartPrice === 'function') {
            setTimeout(updateDesktopStickyCartPrice, 100);
        }

        // Visual feedback on color options
        document.querySelectorAll('.color-option').forEach(opt => {
            opt.classList.remove('active');
        });
        // Find the clicked color option and add active class
        const colorOptions = document.querySelectorAll('.color-option');
        colorOptions.forEach(option => {
            if (option.dataset.color === color) {
                option.classList.add('active');
            }
        });

        // Update URL with ?variant= parameter (without page reload)
        const url = new URL(window.location);
        url.searchParams.set('variant', color);
        window.history.pushState({}, '', url);

        // NEW: Update images based on selected variant
        updateImagesForVariant(color);

        // Update timeline dates based on selected variant
        updateTimelineForVariant(color);

        // Out-of-stock UI: toggle notification card + disable CTA when sold out
        applyOutOfStockState(color, variantId, '#oos-chair-desktop', '#ergonix-chair-cta');
    }

    /**
     * Render OOS card + disable add-to-cart for the given color/variant.
     * Used by both the desktop and mobile color selection paths.
     *
     * Uses inventory_quantity (not variant.available) because the store
     * runs Shopify's "continue selling when out of stock" policy — so
     * .available stays true at 0 stock and would mask the sold-out state.
     */
    function applyOutOfStockState(color, variantId, cardSelector, ctaSelector) {
        const data = (window.productVariantsData || []).find(v => v.option1 === color);
        const card = document.querySelector(cardSelector);
        const cta = document.querySelector(ctaSelector);
        // 'continue' policy = merchant allows selling at 0 stock; never OOS.
        const isSoldOut = data
            ? (!!data.inventory_management && (data.inventory_quantity || 0) <= 0 && data.inventory_policy !== 'continue')
            : false;

        if (window.ErgonixOOS && card) {
            if (isSoldOut) {
                window.ErgonixOOS.show(card, {
                    variantId: variantId,
                    productId: (window.productData && window.productData.id) || ''
                });
            } else {
                window.ErgonixOOS.hide(card);
            }
        }
        if (cta) {
            cta.disabled = isSoldOut;
            cta.classList.toggle('order-btn--soldout', isSoldOut);
            cta.classList.toggle('mobile-order-button--soldout', isSoldOut);
        }
    }

    function updateImagesForVariant(color) {
        const variantData = window.productVariantsData ? window.productVariantsData.find(v => v.option1 === color) : null;
        if (!variantData || !variantData.featured_image) return;

        const fi = variantData.featured_image;

        // Update first thumbnail (support both old and new selectors)
        let thumbnails = document.querySelectorAll('.ergonix-wrapper .thumbnails-container .thumbnail');
        if (thumbnails.length === 0) {
            thumbnails = document.querySelectorAll('.ergonix-wrapper .thumbnail-image');
        }
        if (thumbnails[0]) {
            thumbnails[0].style.backgroundImage = `url('${fi.thumb}')`;
            thumbnails[0].setAttribute('data-full-image', fi.src);
        }

        // Also update allProductMedia[0] if it's an image
        const media = getMedia();
        if (media[0] && media[0].type === 'image') {
            media[0].src = fi.src;
            media[0].thumb = fi.thumb;
        }

        currentImage = 0;
        changeMedia(0);
    }

    /**
     * The Black variant has a longer delivery window. Shopify's option1
     * value is localized per market (Black/Czarny/Juoda) so we match all
     * spellings — strict equality on 'Black' breaks on PL/LT.
     */
    function isLongDeliveryColor(color) {
        if (!color) return false;
        var lower = String(color).toLowerCase();
        return lower === 'black' || lower === 'czarny' || lower === 'juoda' || lower === 'juodas';
    }

    // Lithuanian and Polish public holidays. Mirrors snippets/ergonix-delivery-dates.liquid;
    // refresh both lists annually. Dates that fall on Sat/Sun are omitted (weekend skip covers them).
    const ERGONIX_HOLIDAYS = {
        lt: new Set([
            '2026-01-01', '2026-02-16', '2026-03-11', '2026-04-06', '2026-05-01',
            '2026-06-24', '2026-07-06', '2026-11-02', '2026-12-24', '2026-12-25',
            '2027-01-01', '2027-02-16', '2027-03-11', '2027-03-29',
            '2027-06-24', '2027-07-06', '2027-11-01', '2027-11-02', '2027-12-24'
        ]),
        pl: new Set([
            '2026-01-01', '2026-01-06', '2026-04-06', '2026-05-01', '2026-06-04',
            '2026-11-11', '2026-12-24', '2026-12-25',
            '2027-01-01', '2027-01-06', '2027-03-29', '2027-05-03', '2027-05-27',
            '2027-11-01', '2027-11-11', '2027-12-24'
        ])
    };

    function isoDate(d) {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    }

    function nextBusinessDays(count) {
        const locale = (document.documentElement.lang || 'lt').toLowerCase();
        const holidays = ERGONIX_HOLIDAYS[locale] || ERGONIX_HOLIDAYS.lt;
        const result = [];
        const cursor = new Date();
        cursor.setHours(12, 0, 0, 0);
        let safety = 60;
        while (result.length < count && safety-- > 0) {
            cursor.setDate(cursor.getDate() + 1);
            const wday = cursor.getDay();
            if (wday === 0 || wday === 6) continue;
            if (holidays.has(isoDate(cursor))) continue;
            result.push(new Date(cursor));
        }
        return result;
    }

    function updateTimelineForVariant(color) {
        const months = (window.cartStrings && window.cartStrings.months) || ['Saus.', 'Vas.', 'Kov.', 'Bal.', 'Geg.', 'Birž.', 'Liep.', 'Rugp.', 'Rugs.', 'Spal.', 'Lapkr.', 'Gruod.'];

        let shipText, deliveryText;

        // Black-as-long-delivery override disabled — all colors now share the
        // default LT/PL business-day window mirrored from ergonix-delivery-dates.
        // if (isLongDeliveryColor(color)) {
        //     shipText = months[4] + ' 9';
        //     deliveryText = months[4] + ' 11';
        // } else {
        const days = nextBusinessDays(4);
        const shipDate = days[0];
        const deliveryStart = days[1];
        const deliveryEnd = days[3];

        shipText = `${months[shipDate.getMonth()]} ${shipDate.getDate()}`;
        if (deliveryStart.getMonth() === deliveryEnd.getMonth()) {
            deliveryText = `${months[deliveryStart.getMonth()]} ${deliveryStart.getDate()}-${deliveryEnd.getDate()}`;
        } else {
            deliveryText = `${months[deliveryStart.getMonth()]} ${deliveryStart.getDate()} - ${months[deliveryEnd.getMonth()]} ${deliveryEnd.getDate()}`;
        }
        // }

        document.querySelectorAll('[data-timeline-type="ship-date"]').forEach(el => {
            el.textContent = shipText;
        });

        document.querySelectorAll('[data-timeline-type="delivery-date"]').forEach(el => {
            el.textContent = deliveryText;
        });

        // Indicator span is now commented out in the Liquid template, but keep
        // the toggle so any cached/preloaded markup still gets hidden.
        document.querySelectorAll('[data-black-delay-indicator]').forEach(el => {
            el.hidden = true;
        });
    }

    // Expose globally so mobile IIFE + other handlers can access them
    window.updateTimelineForVariant = updateTimelineForVariant;
    window.isLongDeliveryColor = isLongDeliveryColor;
    window.ergonixApplyOOS = applyOutOfStockState;

    function toggleSection(header) {
        const content = header.nextElementSibling;
        const icon = header.querySelector('.info-toggle svg');

        if (content && icon) {
            if (content.classList.contains('active')) {
                content.classList.remove('active');
                // Change to plus icon
                icon.innerHTML = '<path d="M10 5V15" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 10H15" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
            } else {
                // Close other sections
                document.querySelectorAll('.ergonix-wrapper .info-content').forEach(c => c.classList.remove('active'));
                document.querySelectorAll('.ergonix-wrapper .info-toggle svg').forEach(i => {
                    i.innerHTML = '<path d="M10 5V15" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 10H15" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
                });

                // Open this section
                content.classList.add('active');
                // Change to minus icon
                icon.innerHTML = '<path d="M5 10H15" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
            }
        }
    }

    // Make functions available through namespace to avoid global pollution
    // Use Object.assign to MERGE with existing methods (inline scripts in sections
    // add toggleSpecifications, toggleFAQ etc. before this deferred script runs)
    window.ErgonixProduct = Object.assign(window.ErgonixProduct || {}, {
        changeMedia: changeMedia,
        changeImage: changeImage,
        previousImage: previousImage,
        nextImage: nextImage,
        selectColor: selectColor,
        toggleSection: toggleSection,
        toggleMute: toggleMute,
        toggleSound: toggleMute,
        playVideo: function() {},
        toggleVideo: function() {}
    });

    // Expose selectColor globally for desktop sticky cart to use (like mobile does)
    window.desktopSelectColor = selectColor;

    // Mobile functions are handled by the second IIFE below

    // Preload all variant images for instant switching
    function preloadAllVariantImages() {
        if (!window.productVariantsData) return;

        console.log('Preloading all variant images for instant switching...');

        window.productVariantsData.forEach(function(variant) {
            if (variant.images && variant.images.length > 0) {
                variant.images.forEach(function(imageData) {
                    // Preload full-size image
                    const img = new Image();
                    img.src = imageData.src;

                    // Preload thumbnail
                    const thumb = new Image();
                    thumb.src = imageData.thumb;
                });
                console.log(`Preloaded ${variant.images.length} images for ${variant.option1} variant`);
            }
        });
    }

    // Initialize
    document.addEventListener('DOMContentLoaded', function() {

        // Check for ?variant= URL parameter
        const urlParams = new URLSearchParams(window.location.search);
        const variantFromUrl = urlParams.get('variant');
        let selectedColor = null;

        // If variant parameter exists and is valid color name
        if (variantFromUrl && ['Black', 'Grey', 'Gray'].includes(variantFromUrl)) {
            selectedColor = variantFromUrl === 'Gray' ? 'Grey' : variantFromUrl; // Normalize Gray to Grey
            console.log('Variant from URL:', selectedColor);

            // Auto-select the color from URL
            selectColor(selectedColor);

            // Update active color swatch visually
            document.querySelectorAll('.ergonix-wrapper .color-option').forEach(option => {
                if (option.dataset.color === selectedColor) {
                    option.classList.add('active');
                } else {
                    option.classList.remove('active');
                }
            });
        } else if (variantFromUrl && window.productVariantsData) {
            // Variant parameter is an ID - look up the exact variant
            const urlVariant = window.productVariantsData.find(v => v.id === variantFromUrl);
            if (urlVariant) {
                console.log('Variant ID from URL, resolved:', urlVariant.option1, urlVariant.option2);
                // Find the correct image: try featured_image, then alt-text match
                let variantImg = urlVariant.featured_image;
                if (!variantImg && window.allProductMedia) {
                    const comboKey = urlVariant.option1 + ' ' + urlVariant.option2;
                    variantImg = window.allProductMedia.find(img => img.alt === comboKey);
                }
                if (variantImg) {
                    const mainImg = document.getElementById('mainImage');
                    if (mainImg) mainImg.src = variantImg.src;
                    // Update first thumbnail to match
                    const firstThumb = document.querySelector('.ergonix-wrapper .thumbnail:first-child');
                    if (firstThumb) {
                        firstThumb.style.backgroundImage = "url('" + variantImg.thumb + "')";
                        firstThumb.setAttribute('data-full-image', variantImg.src);
                    }
                } else {
                    // No variant-specific image found, use color-based init
                    updateImagesForVariant(urlVariant.option1);
                }
            }
        } else {
            // No URL parameter - HTML already renders the correct default image.
            // Skip updateImagesForVariant to prevent image flash/reload.
            console.log('No URL variant param - skipping desktop image update (HTML already correct)');
        }

        updateThumbnails();

        // Preload all variant images after page load for instant switching
        setTimeout(preloadAllVariantImages, 500);

        // Initial OOS state (covers default color when no ?variant= param)
        var activeSwatch = document.querySelector('.ergonix-wrapper .color-option.active');
        if (activeSwatch) {
            var initColor = activeSwatch.dataset.color;
            var initVariantId = activeSwatch.dataset.variantId || (window.productVariants && window.productVariants[initColor]);
            applyOutOfStockState(initColor, initVariantId, '#oos-chair-desktop', '#ergonix-chair-cta');
        }
    });
})();

// Ridge-style Mobile Slider - track-based translateX with touch drag
(function() {
    let currentIndex = 0;
    let totalSlides = 0;

    // Touch / drag state
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let dragOffset = 0;        // px offset from finger drag
    let trackWidth = 0;
    let directionLocked = false;
    let isHorizontal = false;

    // Lazy-load state
    let slidesLoaded = new Set([0]);
    let galleryInitialized = false;

    function getTrack() { return document.getElementById('mobileSliderTrack'); }
    function getSlides() { return document.querySelectorAll('.mobile-slider__slide'); }
    function getDots() { return document.querySelectorAll('.mobile-slider__dot'); }

    // ---- Initialization ----
    function initializeMobileGallery() {
        const slider = document.getElementById('mobileSlider');
        if (!slider) return;

        const slides = getSlides();
        totalSlides = slides.length;
        if (totalSlides === 0) return;

        // Guard: only attach touch handlers once (resize handler can re-call this)
        if (!galleryInitialized) {
            slider.addEventListener('touchstart', onTouchStart, { passive: true });
            slider.addEventListener('touchmove', onTouchMove, { passive: false });
            slider.addEventListener('touchend', onTouchEnd, { passive: true });
            galleryInitialized = true;
        }

        // Keyboard
        document.addEventListener('keydown', function(e) {
            if (window.innerWidth > 768) return;
            if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(currentIndex - 1); }
            if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(currentIndex + 1); }
        });

        // Preload slide 1 (slide 0 is already eager)
        preloadSlide(1);

        // Initialize slider position and load video on slide 0 if needed
        goToSlide(0);
    }

    // ---- Track position ----
    function setTrackPosition(px, animate) {
        const track = getTrack();
        if (!track) return;
        if (animate) {
            track.classList.add('is-animating');
        } else {
            track.classList.remove('is-animating');
        }
        track.style.transform = 'translateX(' + px + 'px)';
    }

    function getBaseOffset() {
        const slider = document.getElementById('mobileSlider');
        trackWidth = slider ? slider.offsetWidth : window.innerWidth;
        return -currentIndex * trackWidth;
    }

    // ---- Touch handlers ----
    function onTouchStart(e) {
        if (e.touches.length !== 1) return;
        const track = getTrack();
        if (track) track.classList.remove('is-animating');

        const slider = document.getElementById('mobileSlider');
        trackWidth = slider ? slider.offsetWidth : window.innerWidth;

        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dragOffset = 0;
        isDragging = true;
        directionLocked = false;
        isHorizontal = false;
    }

    function onTouchMove(e) {
        if (!isDragging || e.touches.length !== 1) return;

        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;

        // Lock direction after 10px of movement
        if (!directionLocked && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
            directionLocked = true;
            isHorizontal = Math.abs(dx) > Math.abs(dy);
            if (!isHorizontal) {
                isDragging = false;
                return;
            }
        }

        if (!isHorizontal) return;
        e.preventDefault();

        // Elastic rubber-band at edges
        let offset = dx;
        if ((currentIndex === 0 && dx > 0) || (currentIndex === totalSlides - 1 && dx < 0)) {
            offset = dx * 0.3;
        }

        dragOffset = offset;
        setTrackPosition(getBaseOffset() + dragOffset, false);
    }

    function onTouchEnd() {
        if (!isDragging) return;
        isDragging = false;

        if (!isHorizontal) {
            // Snap back if not horizontal
            setTrackPosition(getBaseOffset(), true);
            return;
        }

        const threshold = trackWidth * 0.2;
        let target = currentIndex;

        if (dragOffset < -threshold && currentIndex < totalSlides - 1) {
            target = currentIndex + 1;
        } else if (dragOffset > threshold && currentIndex > 0) {
            target = currentIndex - 1;
        }

        dragOffset = 0;
        goToSlide(target);
    }

    // ---- Navigation ----
    function goToSlide(index) {
        if (totalSlides === 0) return; // Not initialized yet
        if (index < 0) index = 0;
        if (index >= totalSlides) index = totalSlides - 1;

        const prevIndex = currentIndex;
        currentIndex = index;

        // Recalc width in case of orientation change
        const slider = document.getElementById('mobileSlider');
        trackWidth = slider ? slider.offsetWidth : window.innerWidth;

        setTrackPosition(getBaseOffset(), true);
        updateDots();

        // Lazy-load current and adjacent slides
        preloadSlide(currentIndex);
        preloadSlide(currentIndex + 1);
        preloadSlide(currentIndex - 1);

        // Video handling: pause previous, play current
        handleVideoTransition(prevIndex, currentIndex);
    }

    function nextImage() { goToSlide(currentIndex + 1); }
    function previousImage() { goToSlide(currentIndex - 1); }
    function selectImage(index) { goToSlide(index); }
    function selectMedia(index) { goToSlide(index); }

    // ---- Dots ----
    function updateDots() {
        const dots = getDots();
        dots.forEach(function(dot, i) {
            dot.classList.toggle('active', i === currentIndex);
        });
    }

    // ---- Lazy load ----
    function preloadSlide(index) {
        if (index < 0 || index >= totalSlides || slidesLoaded.has(index)) return;
        slidesLoaded.add(index);

        const slide = getSlides()[index];
        if (!slide) return;

        const img = slide.querySelector('.mobile-slider__image');
        if (img) {
            const fullSrc = img.getAttribute('data-full-src');
            const fullSrcset = img.getAttribute('data-full-srcset');
            if (fullSrc && img.src !== fullSrc) {
                img.src = fullSrc;
                if (fullSrcset) img.srcset = fullSrcset;
            }
        }
    }

    // ---- Video handling ----
    function handleVideoTransition(prevIdx, newIdx) {
        // Pause video on previous slide
        if (prevIdx !== newIdx) {
            const prevSlide = getSlides()[prevIdx];
            if (prevSlide) {
                const prevVideo = prevSlide.querySelector('.mobile-slider__video');
                if (prevVideo) { prevVideo.pause(); }
            }
        }

        // Autoplay video on current slide
        const curSlide = getSlides()[newIdx];
        if (curSlide && curSlide.getAttribute('data-media-type') === 'video') {
            const video = curSlide.querySelector('.mobile-slider__video');
            if (video) {
                const src = video.getAttribute('data-src');
                if (src && !video.src) { video.src = src; }
                video.currentTime = 0;
                video.play().catch(function() {});
            }
        }
    }

    function mobileToggleMute(event, slideIndex) {
        if (event) event.stopPropagation();
        var slide;
        if (typeof slideIndex === 'number') {
            slide = getSlides()[slideIndex];
        } else {
            slide = getSlides()[currentIndex];
        }
        if (!slide) return;

        var video = slide.querySelector('.mobile-slider__video');
        if (!video) return;

        video.muted = !video.muted;

        var btn = slide.querySelector('.mobile-slider__mute-btn');
        if (btn) {
            var volIcon = btn.querySelector('.icon-vol');
            var mutedIcon = btn.querySelector('.icon-muted');
            if (volIcon) volIcon.style.display = video.muted ? 'none' : 'inline';
            if (mutedIcon) mutedIcon.style.display = video.muted ? 'inline' : 'none';
        }
    }
    
    
    // Mobile color translations via locale strings
    const mobileColorTranslations = window.cartStrings ? {
        'Grey': window.cartStrings.colorGrey || 'Grey',
        'Gray': window.cartStrings.colorGrey || 'Grey',
        'Black': window.cartStrings.colorBlack || 'Black',
        'Szary': window.cartStrings.colorGrey || 'Grey',
        'Czarny': window.cartStrings.colorBlack || 'Black',
        'Pilka': window.cartStrings.colorGrey || 'Grey',
        'Juoda': window.cartStrings.colorBlack || 'Black'
    } : { 'Grey': 'Grey', 'Gray': 'Grey', 'Black': 'Black' };

    function mobileTranslateColor(color) {
        return mobileColorTranslations[color] || color;
    }

    function mobileSelectColor(color) {
        // Update mobile color selection with Lithuanian translation
        const colorLabel = document.querySelector('.ergonix-wrapper .mobile-color-label strong');
        if (colorLabel) {
            colorLabel.textContent = mobileTranslateColor(color);
        }

        // Variant mapping - same as desktop (will be populated dynamically)
        const variantMap = window.productVariants || {
            'Black': '52380192702797',
            'Grey': '52380192735565'
        };

        const variantId = variantMap[color];

        // Update hidden form input
        const input = document.getElementById('variant-id-input');
        if (input) {
            input.value = variantId;
        }

        // Update global state
        window.currentSelectedVariant = variantId;

        // Update price display
        if (window.cart && window.cart.updatePriceDisplay) {
            window.cart.updatePriceDisplay(variantId);
        }

        // Update sticky cart price (if sticky cart exists)
        if (typeof updateStickyCartPrice === 'function') {
            setTimeout(updateStickyCartPrice, 100); // Small delay to let price update finish
        }

        // Update color options visual state
        const colorOptions = document.querySelectorAll('.ergonix-wrapper .mobile-color-option');
        colorOptions.forEach(option => {
            option.classList.remove('active');
        });

        // Find and activate the selected color
        colorOptions.forEach(option => {
            if (option.dataset.color === color) {
                option.classList.add('active');
            }
        });

        // NEW: Update images based on selected variant
        updateMobileImagesForVariant(color);

        // Update chair color preview image
        var chairPreview = document.getElementById('mobileChairPreviewImg');
        if (chairPreview) {
            var vData = window.productVariantsData ? window.productVariantsData.find(function(v) { return v.option1 === color; }) : null;
            if (vData && vData.featured_image) {
                chairPreview.src = vData.featured_image.mobileSrc || vData.featured_image.src;
            }
        }

        // Update timeline dates based on selected variant
        window.updateTimelineForVariant(color);

        // Out-of-stock UI: notification card + disabled CTA when sold out
        if (window.ergonixApplyOOS) {
            window.ergonixApplyOOS(color, variantId, '#oos-chair-mobile', '#ergonix-chair-mobile-cta');
        }
    }

    function updateMobileImagesForVariant(color) {
        if (window.innerWidth > 768) return;

        var variantData = window.productVariantsData ? window.productVariantsData.find(function(v) { return v.option1 === color; }) : null;
        if (!variantData || !variantData.featured_image) return;

        var fi = variantData.featured_image;
        var fullUrl = fi.mobileSrc || fi.src;

        // Update first slide's image with variant featured image
        var slides = getSlides();
        if (slides[0]) {
            var img = slides[0].querySelector('.mobile-slider__image');
            if (img) {
                img.src = fullUrl;
                img.srcset = fullUrl + ' 600w';
                img.setAttribute('data-full-src', fullUrl);
                img.setAttribute('data-full-srcset', fullUrl + ' 600w');
            }
        }

        // Pause any playing videos
        slides.forEach(function(slide) {
            var video = slide.querySelector('.mobile-slider__video');
            if (video) video.pause();
        });

        // Reset slider to slide 0
        goToSlide(0);
    }


    function openMobileCart() {
        // Mobile cart functionality
        console.log('Mobile cart opened');
    }
    
    function initMobileCarousel() {
        // Legacy - now handled by initializeMobileGallery
        initializeMobileGallery();
    }

    function handleResponsiveSwitch() {
        if (window.innerWidth <= 768) {
            initializeMobileGallery();
        }
    }
    
    
    // Gallery-aware scroll behavior for header and announcement bar
    const initScrollBehavior = function(retryCount = 0) {
            let lastScrollY = 0;
            let ticking = false;
            let isGalleryVisible = false;
            let observerConnected = false;
            
            // iOS detection for momentum scrolling
            const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
            const scrollThreshold = isIOS ? 10 : 5; // Higher threshold for iOS
            
            // Use more flexible selectors that work with template suffixes
            const announcementBar = document.querySelector('[id^="mobileAnnouncementBar"]');
            const mobileHeader = document.querySelector('.mobile-header');
            
            console.log('ScrollBehavior: Looking for elements:', {
                announcementBar: !!announcementBar,
                mobileHeader: !!mobileHeader,
                windowWidth: window.innerWidth,
                retryCount: retryCount
            });
            
            if (!announcementBar || !mobileHeader) {
                // Limit retries to prevent infinite loop
                if (retryCount < 5) {
                    console.warn(`ScrollBehavior: Elements not found, retry ${retryCount + 1}/5 in 500ms...`);
                    setTimeout(() => initScrollBehavior(retryCount + 1), 500);
                    return;
                } else {
                    console.log('ScrollBehavior: Elements not found after 5 retries. This is normal for Ergonix pages - header scroll behavior disabled.');
                    return;
                }
            }
            
            console.log('ScrollBehavior: Elements found, initializing...');
            
            // Simple scroll handler - no complex observers needed
            const updateScrollDirection = () => {
                const currentScrollY = window.scrollY;
                
                console.log('ScrollBehavior: Scroll detected', { currentScrollY, lastScrollY });
                
                // Skip if scroll is below threshold
                if (Math.abs(currentScrollY - lastScrollY) < scrollThreshold) {
                    ticking = false;
                    return;
                }
                
                const isScrollingDown = currentScrollY > lastScrollY;
                const isScrollingUp = currentScrollY < lastScrollY;
                
                if (isScrollingDown && currentScrollY > 50) {
                    // Hide when scrolling down past 50px
                    console.log('ScrollBehavior: Hiding elements (scrolling down)');
                    announcementBar.classList.add('hidden');
                    mobileHeader.classList.add('hidden');
                } else if (isScrollingUp) {
                    // Show when scrolling up
                    console.log('ScrollBehavior: Showing elements (scrolling up)');
                    announcementBar.classList.remove('hidden');
                    mobileHeader.classList.remove('hidden');
                }
                
                lastScrollY = currentScrollY;
                ticking = false;
            };
            
            const onScroll = () => {
                if (!ticking) {
                    window.requestAnimationFrame(updateScrollDirection);
                    ticking = true;
                }
            };
            
            window.addEventListener('scroll', onScroll, { passive: true });
            console.log('ScrollBehavior: Scroll listener attached successfully');
        };
    
    // Preload all variant images for instant mobile switching
    function preloadAllMobileVariantImages() {
        if (!window.productVariantsData || window.innerWidth > 768) return;

        console.log('Preloading all mobile variant images for instant switching...');

        window.productVariantsData.forEach(function(variant) {
            if (variant.images && variant.images.length > 0) {
                variant.images.forEach(function(imageData) {
                    // Preload full-size image
                    const img = new Image();
                    img.src = imageData.src;

                    // Preload thumbnail
                    const thumb = new Image();
                    thumb.src = imageData.thumb;
                });
                console.log(`Preloaded ${variant.images.length} mobile images for ${variant.option1} variant`);
            }
        });
    }

    // Initialize mobile functionality
    document.addEventListener('DOMContentLoaded', function() {
        // Initialize gallery
        if (window.innerWidth <= 768) {
            setTimeout(initializeMobileGallery, 100);
            // Initialize scroll behavior for mobile
            initScrollBehavior();

            // Initialize mobile gallery with correct variant images on page load
            setTimeout(function() {
                var targetColor = null;
                // Check URL for variant ID and resolve to color
                var urlParams = new URLSearchParams(window.location.search);
                var variantFromUrl = urlParams.get('variant');
                console.log('[MobileInit] URL variant param:', variantFromUrl, '| productVariantsData count:', window.productVariantsData ? window.productVariantsData.length : 0);
                if (variantFromUrl && window.productVariantsData) {
                    // Try color name first
                    if (['Black', 'Grey', 'Gray'].includes(variantFromUrl)) {
                        targetColor = variantFromUrl === 'Gray' ? 'Grey' : variantFromUrl;
                        console.log('[MobileInit] Resolved color name directly:', targetColor);
                    } else {
                        // Variant ID - look up
                        var urlVariant = window.productVariantsData.find(function(v) { return v.id === variantFromUrl; });
                        if (urlVariant) {
                            targetColor = urlVariant.option1;
                            console.log('[MobileInit] Resolved variant ID to color:', targetColor, '| variant:', urlVariant.title);
                        } else {
                            console.log('[MobileInit] Variant ID NOT FOUND in productVariantsData. IDs available:', window.productVariantsData.map(function(v) { return v.id; }));
                        }
                    }
                }
                if (!targetColor) {
                    // No URL variant param - HTML already renders the correct default image.
                    // Skip updateMobileImagesForVariant to prevent image flash/reload.
                    console.log('[MobileInit] No URL variant - skipping image update (HTML already correct)');
                }
                if (targetColor) {
                    console.log('[MobileInit] Calling updateMobileImagesForVariant with:', targetColor);
                    updateMobileImagesForVariant(targetColor);
                }
                // Log final state
                var firstSlideImg = document.querySelector('.mobile-slider__slide:first-child .mobile-slider__image');
                if (firstSlideImg) console.log('[MobileInit] Final first slide src:', firstSlideImg.src);
            }, 200); // Small delay to ensure gallery is initialized

            // Safety net: ensure slider is at slide 0 with correct transform
            setTimeout(function() {
                var track = document.getElementById('mobileSliderTrack');
                if (track && currentIndex === 0) {
                    var currentTransform = track.style.transform;
                    if (currentTransform !== 'translateX(0px)') {
                        console.log('[MobileSafetyNet] Track position wrong:', currentTransform, '- correcting to translateX(0px)');
                        track.style.transform = 'translateX(0px)';
                    }
                }
            }, 500);

            // Preload all variant images for instant switching
            setTimeout(preloadAllMobileVariantImages, 600);
        }

        // Handle responsive switching on resize
        let resizeTimeout;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                if (window.innerWidth <= 768) {
                    initializeMobileGallery();
                }
            }, 250);
        });
    });
    
    // Modern Accordion functionality with accessibility
    document.addEventListener('DOMContentLoaded', function() {
      const accordionItems = document.querySelectorAll('.mobile-accordion-details .accordion-item');
      
      accordionItems.forEach(item => {
        const header = item.querySelector('.accordion-header');
        const content = item.querySelector('.accordion-content');
        const icon = item.querySelector('.accordion-icon');
        
        header.addEventListener('click', function() {
          const isExpanded = item.classList.contains('expanded');
          
          if (isExpanded) {
            // Collapse
            item.classList.remove('expanded');
            content.classList.remove('expanded');
            icon.classList.remove('minus');
            icon.classList.add('plus');
            
            // Update ARIA attributes
            header.setAttribute('aria-expanded', 'false');
            content.setAttribute('aria-hidden', 'true');
          } else {
            // Expand
            item.classList.add('expanded');
            content.classList.add('expanded');
            icon.classList.remove('plus');
            icon.classList.add('minus');
            
            // Update ARIA attributes
            header.setAttribute('aria-expanded', 'true');
            content.setAttribute('aria-hidden', 'false');
          }
        });
        
        // Keyboard support
        header.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            header.click();
          }
        });
      });
    });
    // ============================================
    // MOBILE STICKY ADD TO CART FUNCTIONALITY
    // ============================================

    // Initialize sticky cart functionality
    function initStickyCart() {
        const stickyCart = document.getElementById('mobile-sticky-cart');

        // Move sticky cart to document.body to avoid position:fixed issues
        // caused by parent transforms/will-change/contain from app embeds or theme CSS
        if (stickyCart && stickyCart.parentElement !== document.body) {
            document.body.appendChild(stickyCart);
        }

        // Device-specific button selection
        let orderBtn;
        if (window.innerWidth <= 768) {
            // Mobile: observe the mobile order button
            orderBtn = document.querySelector('.mobile-order-button');
            console.log('Mobile mode: looking for .mobile-order-button');
        } else {
            // Desktop fallback: observe desktop button (though sticky cart is mobile-only)
            orderBtn = document.querySelector('.order-btn');
            console.log('Desktop mode: looking for .order-btn');
        }

        // Also observe the price section
        const priceSection = document.querySelector('.mobile-price-wrapper');

        if (!stickyCart || !orderBtn) {
            console.warn('Sticky cart init failed:', {
                stickyCart: !!stickyCart,
                orderBtn: !!orderBtn,
                priceSection: !!priceSection,
                orderBtnClass: orderBtn ? orderBtn.className : 'not found',
                windowWidth: window.innerWidth
            });
            return;
        }

        console.log('Initializing sticky cart...', {
            stickyCart,
            orderBtn,
            priceSection,
            buttonClass: orderBtn.className,
            windowWidth: window.innerWidth
        });

        // Track visibility state of both elements
        let orderBtnVisible = true;
        let priceSectionVisible = true;

        // Function to update sticky cart visibility based on both elements
        function updateStickyCartVisibility() {
            // Show sticky cart only when BOTH order button AND price section are out of view
            if (!orderBtnVisible && !priceSectionVisible) {
                stickyCart.classList.add('visible');
                console.log('Both order button and price out of view → showing sticky cart');
            } else {
                stickyCart.classList.remove('visible');
                console.log('Order button or price in view → hiding sticky cart', {
                    orderBtnVisible,
                    priceSectionVisible
                });
            }
        }

        // Observer for order button
        const orderBtnObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                orderBtnVisible = entry.isIntersecting;
                updateStickyCartVisibility();
            });
        }, {
            threshold: 0,  // Trigger as soon as any part enters/leaves viewport
            rootMargin: '0px 0px -50px 0px'  // 50px buffer from bottom of viewport
        });

        orderBtnObserver.observe(orderBtn);
        console.log('IntersectionObserver attached to order button:', orderBtn.className);

        // Observer for price section (if it exists)
        if (priceSection) {
            const priceSectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    priceSectionVisible = entry.isIntersecting;
                    updateStickyCartVisibility();
                });
            }, {
                threshold: 0,
                rootMargin: '0px 0px -50px 0px'
            });

            priceSectionObserver.observe(priceSection);
            console.log('IntersectionObserver attached to price section');
        }
        
        // Initialize sticky cart prices on load
        setTimeout(updateStickyCartPrice, 100);
        console.log('Initializing sticky cart prices...');

        // Visual Viewport API: Keep sticky cart anchored to visual viewport bottom
        // Only adjust when virtual keyboard is open (large offset), not for browser chrome
        if (window.visualViewport) {
            const adjustStickyCartPosition = () => {
                const offset = window.innerHeight - window.visualViewport.height;
                // Only adjust for significant offsets (virtual keyboard > 150px)
                // Browser address bar changes are small (~50-80px) and cause jitter
                if (offset > 150) {
                    stickyCart.style.bottom = offset + 'px';
                } else {
                    stickyCart.style.bottom = '0px';
                }
            };

            window.visualViewport.addEventListener('resize', adjustStickyCartPosition);
            adjustStickyCartPosition();
        }
        
        // Handle sticky cart color selection
        const stickyColorDots = document.querySelectorAll('.sticky-color-selector .color-dot');
        stickyColorDots.forEach(dot => {
            dot.addEventListener('click', function(e) {
                e.preventDefault();
                
                const color = this.dataset.color;
                console.log('Sticky color dot clicked:', color);
                
                // Update active state in sticky cart
                stickyColorDots.forEach(d => d.classList.remove('active'));
                this.classList.add('active');
                
                // Call the same function as main mobile color selector
                if (window.mobileSelectColor) {
                    window.mobileSelectColor(color);
                    console.log('Called mobileSelectColor with:', color);
                } else {
                    console.error('mobileSelectColor function not available');
                }
            });
        });
        
        // Sync sticky cart with main color selector changes
        const mainColorBtns = document.querySelectorAll('.mobile-color-option');
        mainColorBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                const color = this.dataset.color;
                console.log('Main color button clicked, syncing sticky cart:', color);
                
                // Update sticky cart active state
                stickyColorDots.forEach(dot => {
                    dot.classList.remove('active');
                    if (dot.dataset.color === color) {
                        dot.classList.add('active');
                    }
                });
                
                // Update price
                setTimeout(updateStickyCartPrice, 100); // Small delay to let main script update
            });
        });
        
        // Handle sticky order button click
        const stickyOrderBtn = document.getElementById('sticky-order-btn');
        if (stickyOrderBtn) {
            stickyOrderBtn.addEventListener('click', function(e) {
                e.preventDefault();
                console.log('Sticky order button clicked');
                
                // Use the same add to cart function as main button
                if (window.cart && window.cart.addToCart) {
                    window.cart.addToCart();
                } else {
                    // Fallback: trigger main order button
                    const mainOrderBtn = document.querySelector('.order-btn');
                    if (mainOrderBtn) {
                        mainOrderBtn.click();
                    }
                }
            });
        }
    }

    // Update sticky cart price based on current selection
    function updateStickyCartPrice() {
        const currentPriceEl = document.getElementById('sticky-current-price');
        const originalPriceEl = document.getElementById('sticky-original-price');
        const discountBadgeEl = document.getElementById('sticky-discount-badge');
        
        // Get prices from MOBILE product area (since sticky cart is mobile-only)
        const mainCurrentPrice = document.getElementById('mobile-price-current');
        const mainOriginalPrice = document.getElementById('mobile-price-original');
        
        console.log('UpdateStickyCartPrice - Found elements:', {
            currentPriceEl: !!currentPriceEl,
            originalPriceEl: !!originalPriceEl,
            mainCurrentPrice: !!mainCurrentPrice,
            mainOriginalPrice: !!mainOriginalPrice,
            mainCurrentText: mainCurrentPrice ? mainCurrentPrice.textContent : 'N/A',
            mainOriginalText: mainOriginalPrice ? mainOriginalPrice.textContent : 'N/A'
        });
        
        if (currentPriceEl && mainCurrentPrice) {
            currentPriceEl.textContent = mainCurrentPrice.textContent;
            console.log('Updated sticky cart current price:', mainCurrentPrice.textContent);
        }
        
        if (originalPriceEl && mainOriginalPrice) {
            originalPriceEl.textContent = mainOriginalPrice.textContent;
            console.log('Updated sticky cart original price:', mainOriginalPrice.textContent);
        }
        
        // Calculate discount percentage (if both prices available)
        if (mainCurrentPrice && mainOriginalPrice && discountBadgeEl) {
            const current = parseFloat(mainCurrentPrice.textContent.replace(/[€$,]/g, ''));
            const original = parseFloat(mainOriginalPrice.textContent.replace(/[€$,]/g, ''));
            
            console.log('Price calculation:', { current, original });
            
            if (current && original && current < original) {
                const discount = Math.round(((original - current) / original) * 100);
                discountBadgeEl.textContent = `-${discount}%`;
                console.log('Updated discount badge:', `-${discount}%`);
            }
        }
    }
    
    // ============================================
    // DESKTOP STICKY ADD TO CART FUNCTIONALITY
    // ============================================
    
    // Initialize desktop sticky cart functionality
    function initDesktopStickyCart() {
        const stickyCart = document.getElementById('desktop-sticky-cart');

        // Move sticky cart to document.body to avoid position:fixed issues
        if (stickyCart && stickyCart.parentElement !== document.body) {
            document.body.appendChild(stickyCart);
        }

        const orderBtn = document.querySelector('.desktop-order-btn, .order-btn');

        if (!stickyCart || !orderBtn) return;
        
        console.log('Initializing desktop sticky cart...', { stickyCart, orderBtn });
        
        // Show sticky cart when main order button is out of view
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    // Main order button is out of view, show sticky cart
                    stickyCart.classList.add('visible');
                    console.log('Main order button out of view, showing desktop sticky cart');
                } else {
                    // Main order button is visible, hide sticky cart
                    stickyCart.classList.remove('visible');
                    console.log('Main order button visible, hiding desktop sticky cart');
                }
            });
        }, { 
            threshold: 0,
            rootMargin: '0px 0px -50px 0px' // Show sticky cart when order button is 50px from bottom
        });
        
        observer.observe(orderBtn);
        
        // Initialize sticky cart prices on load
        setTimeout(updateDesktopStickyCartPrice, 100);
        console.log('Initializing desktop sticky cart prices...');
        
        // Handle sticky cart color selection
        const stickyColorDots = document.querySelectorAll('.desktop-sticky-color-selector .color-dot');
        stickyColorDots.forEach(dot => {
            dot.addEventListener('click', function(e) {
                e.preventDefault();
                
                const color = this.dataset.color;
                console.log('Desktop sticky color dot clicked:', color);
                
                // Update active state in sticky cart
                stickyColorDots.forEach(d => d.classList.remove('active'));
                this.classList.add('active');

                // Update color name display
                const colorName = document.getElementById('desktop-sticky-color-name');
                if (colorName) {
                    const cs = window.cartStrings || {};
                    const ct = { 'Grey': cs.colorGrey || 'Grey', 'Gray': cs.colorGrey || 'Grey', 'Black': cs.colorBlack || 'Black', 'Szary': cs.colorGrey || 'Grey', 'Czarny': cs.colorBlack || 'Black', 'Pilka': cs.colorGrey || 'Grey', 'Juoda': cs.colorBlack || 'Black' };
                    colorName.textContent = ct[color] || color;
                    console.log('Updated desktop sticky color name to:', ct[color] || color);
                }
                
                // Call the desktop color selection function directly (like mobile does)
                if (window.desktopSelectColor) {
                    window.desktopSelectColor(color);
                    console.log('Called desktopSelectColor with:', color);
                } else if (window.ErgonixProduct && window.ErgonixProduct.selectColor) {
                    window.ErgonixProduct.selectColor(color);
                    console.log('Called ErgonixProduct.selectColor with:', color);
                } else {
                    console.error('No desktop color selection function available');
                }
                
                // Update sticky cart price after a delay to let main script update
                setTimeout(updateDesktopStickyCartPrice, 150);
            });
        });
        
        // Sync sticky cart with main color selector changes
        const mainColorBtns = document.querySelectorAll('.color-option');
        mainColorBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                // Determine color from background style (since desktop doesn't use data-color)
                const bgStyle = window.getComputedStyle(this).backgroundColor;
                let color = 'Black'; // default
                if (bgStyle.includes('196') || bgStyle.includes('rgb(196, 196, 196)')) {
                    color = 'Grey';
                }

                console.log('Main desktop color button clicked, syncing sticky cart:', color);
                
                // Update sticky cart active state
                stickyColorDots.forEach(dot => {
                    dot.classList.remove('active');
                    if (dot.dataset.color === color) {
                        dot.classList.add('active');
                    }
                });
                
                // Update color name
                const colorName = document.getElementById('desktop-sticky-color-name');
                if (colorName) {
                    const cs = window.cartStrings || {};
                    const ct = { 'Grey': cs.colorGrey || 'Grey', 'Gray': cs.colorGrey || 'Grey', 'Black': cs.colorBlack || 'Black', 'Szary': cs.colorGrey || 'Grey', 'Czarny': cs.colorBlack || 'Black', 'Pilka': cs.colorGrey || 'Grey', 'Juoda': cs.colorBlack || 'Black' };
                    colorName.textContent = ct[color] || color;
                }
                
                // Update price
                setTimeout(updateDesktopStickyCartPrice, 100); // Small delay to let main script update
            });
        });
        
        // Handle sticky checkout button click
        const stickyCheckoutBtn = document.getElementById('desktop-sticky-checkout-btn');
        if (stickyCheckoutBtn) {
            stickyCheckoutBtn.addEventListener('click', function(e) {
                e.preventDefault();
                console.log('Desktop sticky checkout button clicked');
                
                // Use the same add to cart function as main button
                if (window.cart && window.cart.addToCart) {
                    window.cart.addToCart();
                } else {
                    // Fallback: trigger main order button
                    const mainOrderBtn = document.querySelector('.order-btn, .desktop-order-btn');
                    if (mainOrderBtn) {
                        mainOrderBtn.click();
                    }
                }
            });
        }
    }
    
    // Update desktop sticky cart price based on current selection
    function updateDesktopStickyCartPrice() {
        const currentPriceEl = document.getElementById('desktop-sticky-current-price');
        const originalPriceEl = document.getElementById('desktop-sticky-original-price');
        const discountBadgeEl = document.getElementById('desktop-sticky-discount-badge');
        
        // Get prices from DESKTOP product area
        const mainCurrentPrice = document.getElementById('desktop-current-price');
        const mainOriginalPrice = document.getElementById('desktop-original-price');
        
        console.log('UpdateDesktopStickyCartPrice - Found elements:', {
            currentPriceEl: !!currentPriceEl,
            originalPriceEl: !!originalPriceEl,
            mainCurrentPrice: !!mainCurrentPrice,
            mainOriginalPrice: !!mainOriginalPrice,
            mainCurrentText: mainCurrentPrice ? mainCurrentPrice.textContent : 'N/A',
            mainOriginalText: mainOriginalPrice ? mainOriginalPrice.textContent : 'N/A'
        });
        
        if (currentPriceEl && mainCurrentPrice) {
            currentPriceEl.textContent = mainCurrentPrice.textContent;
            console.log('Updated desktop sticky cart current price:', mainCurrentPrice.textContent);
        }

        if (originalPriceEl && mainOriginalPrice) {
            originalPriceEl.textContent = mainOriginalPrice.textContent;
            console.log('Updated desktop sticky cart original price:', mainOriginalPrice.textContent);
        }

        // Calculate discount percentage (if both prices available)
        if (mainCurrentPrice && mainOriginalPrice && discountBadgeEl) {
            const current = parseFloat(mainCurrentPrice.textContent.replace(/[^\d.,]/g, '').replace(',', '.'));
            const original = parseFloat(mainOriginalPrice.textContent.replace(/[^\d.,]/g, '').replace(',', '.'));
            
            console.log('Desktop price calculation:', { current, original });
            
            if (current && original && current < original) {
                const discount = Math.round(((original - current) / original) * 100);
                discountBadgeEl.textContent = `-${discount}%`;
                console.log('Updated desktop sticky discount badge:', `-${discount}%`);
            }
        }
    }
    
    // Initialize sticky carts when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        // Small delay to ensure all elements are loaded
        if (window.innerWidth <= 768) {
            // Mobile only
            setTimeout(initStickyCart, 500);
        } else {
            // Desktop only
            setTimeout(initDesktopStickyCart, 500);
        }
    });
    
    // Also initialize on window load as backup
    window.addEventListener('load', function() {
        if (window.innerWidth <= 768) {
            // Mobile only
            setTimeout(initStickyCart, 100);
        } else {
            // Desktop only
            setTimeout(initDesktopStickyCart, 100);
        }
    });

    // Re-initialize on resize/orientation change for mobile
    let stickyCartResizeTimer;
    window.addEventListener('resize', function() {
        if (window.innerWidth <= 768) {
            // Debounce resize events to avoid excessive re-initialization
            clearTimeout(stickyCartResizeTimer);
            stickyCartResizeTimer = setTimeout(() => {
                console.log('Window resized/rotated, reinitializing mobile sticky cart');
                initStickyCart();
            }, 250);
        }
    });

    // ============================================
    // DESKTOP GALLERY STICKY SCROLLING
    // ============================================
    
    function initDesktopGallerySticky() {
        // Only run on desktop
        if (window.innerWidth <= 768) return;
        
        const thumbnailsSection = document.querySelector('.ergonix-wrapper .thumbnails-section');
        const mainImageSection = document.querySelector('.ergonix-wrapper .main-image-section');
        const infoCard = document.querySelector('.ergonix-wrapper .info-card');
        
        if (!thumbnailsSection || !mainImageSection || !infoCard) return;
        
        console.log('Initializing desktop gallery sticky scrolling...');
        
        let stickyActive = true;
        
        // Calculate when to stop sticky behavior
        function updateStickyBehavior() {
            const infoCardRect = infoCard.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const headerHeight = 134;
            
            // Calculate the bottom of info-card relative to viewport
            const infoCardBottom = infoCardRect.bottom;
            
            // If info-card bottom is at header height, stop sticky
            const shouldStopSticky = infoCardBottom <= (headerHeight + 50); // 50px buffer
            
            if (shouldStopSticky && stickyActive) {
                // Add transitioning class for smooth animation
                thumbnailsSection.classList.add('transitioning');
                mainImageSection.classList.add('transitioning');
                
                // Stop sticky behavior - make sections follow normal flow
                setTimeout(() => {
                    thumbnailsSection.style.position = 'relative';
                    thumbnailsSection.style.top = 'auto';
                    mainImageSection.style.position = 'relative';
                    mainImageSection.style.top = 'auto';
                    stickyActive = false;
                    console.log('Stopped sticky at info-card bottom');
                    
                    // Remove transitioning class after animation
                    setTimeout(() => {
                        thumbnailsSection.classList.remove('transitioning');
                        mainImageSection.classList.remove('transitioning');
                    }, 500);
                }, 50);
            } else if (!shouldStopSticky && !stickyActive) {
                // Add transitioning class for smooth animation
                thumbnailsSection.classList.add('transitioning');
                mainImageSection.classList.add('transitioning');
                
                // Resume sticky behavior
                setTimeout(() => {
                    thumbnailsSection.style.position = 'sticky';
                    thumbnailsSection.style.top = headerHeight + 'px';
                    mainImageSection.style.position = 'sticky';
                    mainImageSection.style.top = headerHeight + 'px';
                    stickyActive = true;
                    console.log('Resumed sticky behavior');
                    
                    // Remove transitioning class after animation
                    setTimeout(() => {
                        thumbnailsSection.classList.remove('transitioning');
                        mainImageSection.classList.remove('transitioning');
                    }, 500);
                }, 50);
            }
        }
        
        // Listen for scroll events
        let ticking = false;
        function handleScroll() {
            if (!ticking) {
                requestAnimationFrame(function() {
                    updateStickyBehavior();
                    ticking = false;
                });
                ticking = true;
            }
        }
        
        window.addEventListener('scroll', handleScroll);
        
        // Initial check and force sticky positioning
        setTimeout(() => {
            // Explicitly set sticky positioning to override any CSS conflicts
            thumbnailsSection.style.position = 'sticky';
            thumbnailsSection.style.top = headerHeight + 'px';
            mainImageSection.style.position = 'sticky';
            mainImageSection.style.top = headerHeight + 'px';
            
            updateStickyBehavior();
            console.log('Forced sticky positioning on initialization');
        }, 100);
        
        // Handle window resize
        window.addEventListener('resize', function() {
            if (window.innerWidth <= 768) {
                // Disable on mobile
                thumbnailsSection.style.position = '';
                thumbnailsSection.style.top = '';
                mainImageSection.style.position = '';
                mainImageSection.style.top = '';
                window.removeEventListener('scroll', handleScroll);
            } else {
                // Re-enable on desktop
                setTimeout(updateStickyBehavior, 100);
            }
        });
    }
    
    // Initialize gallery sticky scrolling
    document.addEventListener('DOMContentLoaded', function() {
        if (window.innerWidth > 768) {
            setTimeout(initDesktopGallerySticky, 600); // After sticky cart init
        }
    });
    
    // Also initialize on window load as backup
    window.addEventListener('load', function() {
        if (window.innerWidth > 768) {
            setTimeout(initDesktopGallerySticky, 200);
        }
    });
    
    // Expose mobile functions globally so HTML can call them
    window.mobileSelectColor = mobileSelectColor;
    
    // ============================================
    // DYNAMIC TIMELINE DATE FUNCTIONALITY
    // ============================================
    
    // Function to update timeline dates dynamically
    function updateTimelineDates() {
        // Update desktop timeline
        const desktopTimelineItems = document.querySelectorAll('.desktop-timeline .timeline-item');
        updateTimelineSection(desktopTimelineItems, 'desktop');

        // Update mobile timeline
        const mobileTimelineItems = document.querySelectorAll('.mobile-timeline .timeline-item');
        updateTimelineSection(mobileTimelineItems, 'mobile');
    }
    
    // Helper function to update a timeline section
    // Only sets the "order placed" date (index 0). Ship/delivery dates
    // are variant-aware and owned by updateTimelineForVariant.
    function updateTimelineSection(timelineItems, sectionType) {
        if (timelineItems.length === 0) return;

        const today = new Date();
        const firstDateElement = timelineItems[0] && timelineItems[0].querySelector('.timeline-date');
        if (firstDateElement) firstDateElement.textContent = formatTimelineDate(today, 0);
    }
    
    // Format a single date for timeline display
    function formatTimelineDate(date, daysOffset) {
        const targetDate = new Date(date);
        targetDate.setDate(targetDate.getDate() + daysOffset);

        const month = getShortMonthName(targetDate.getMonth());
        const day = targetDate.getDate();

        return `${month} ${day}`;
    }
    
    // Format a date range for timeline display
    function formatTimelineDateRange(date, startDaysOffset, endDaysOffset) {
        const startDate = new Date(date);
        const endDate = new Date(date);

        startDate.setDate(startDate.getDate() + startDaysOffset);
        endDate.setDate(endDate.getDate() + endDaysOffset);

        const startMonth = getShortMonthName(startDate.getMonth());
        const endMonth = getShortMonthName(endDate.getMonth());
        const startDay = startDate.getDate();
        const endDay = endDate.getDate();

        // If same month, show "Spal. 5-6"
        if (startDate.getMonth() === endDate.getMonth()) {
            return `${startMonth} ${startDay}-${endDay}`;
        } else {
            // If different months, show "Spal. 30 - Lapkr. 1"
            return `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
        }
    }
    
    // Get ordinal suffix for day (1st, 2nd, 3rd, 4th, etc.)
    function getOrdinalSuffix(day) {
        if (day >= 11 && day <= 13) {
            return 'th';
        }
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }
    
    // Get localized short month name
    function getShortMonthName(monthIndex) {
        const months = (window.cartStrings && window.cartStrings.months) || ['Saus.', 'Vas.', 'Kov.', 'Bal.', 'Geg.', 'Birž.', 'Liep.', 'Rugp.', 'Rugs.', 'Spal.', 'Lapkr.', 'Gruod.'];
        return months[monthIndex];
    }
    
    // Initialize timeline dates on page load
    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function () {
            updateTimelineDates();
            // Apply variant-aware ship/delivery dates using the current URL variant
            if (window.updateTimelineForVariant) {
                const variantFromUrl = new URLSearchParams(window.location.search).get('variant');
                const normalized = variantFromUrl === 'Gray' ? 'Grey' : variantFromUrl;
                window.updateTimelineForVariant(normalized || 'Grey');
            }
        }, 100);
    });
    
    // Expose updateTimelineDates globally for manual updates if needed
    window.updateTimelineDates = updateTimelineDates;

    // Mobile Video Functions
    function playVideo(videoElement) {
        const overlay = document.getElementById('mobileVideoPlayOverlay');
        if (videoElement && overlay) {
            videoElement.play();
            overlay.classList.add('hidden');
        }
    }

    function pauseVideo(videoElement) {
        const overlay = document.getElementById('mobileVideoPlayOverlay');
        if (videoElement && overlay) {
            videoElement.pause();
            overlay.classList.remove('hidden');
        }
    }

    // Awkward Sitting Video Functions
    function playAwkwardVideo(videoElement) {
        const overlay = document.getElementById('mobileAwkwardPlayOverlay');
        if (videoElement && overlay) {
            videoElement.play();
            overlay.classList.add('hidden');
        }
    }

    function pauseAwkwardVideo(videoElement) {
        const overlay = document.getElementById('mobileAwkwardPlayOverlay');
        if (videoElement && overlay) {
            videoElement.pause();
            overlay.classList.remove('hidden');
        }
    }

    // Armrest Carousel Functions
    let armrestCurrentIndex = 0;
    let armrestStartX = 0;
    let armrestCurrentX = 0;
    let armrestIsDragging = false;
    let armrestContainerWidth = 0;
    let armrestStartY = 0;
    let armrestCurrentY = 0;

    function initArmrestCarousel() {
        const container = document.getElementById('armrestCarousel');
        if (!container) return;
        
        armrestContainerWidth = container.offsetWidth;
        
        // Touch events for swipe functionality
        container.addEventListener('touchstart', handleArmrestTouchStart, { passive: false });
        container.addEventListener('touchmove', handleArmrestTouchMove, { passive: false });
        container.addEventListener('touchend', handleArmrestTouchEnd, { passive: false });
        
        // Auto-play first video
        playCurrentArmrestVideo();
    }

    function handleArmrestTouchStart(e) {
        if (e.touches.length === 1) {
            armrestStartX = e.touches[0].clientX;
            armrestStartY = e.touches[0].clientY;
            armrestCurrentX = armrestStartX;
            armrestCurrentY = armrestStartY;
            armrestIsDragging = true;
            
            // Update container width in case of orientation change
            const container = document.getElementById('armrestCarousel');
            armrestContainerWidth = container ? container.offsetWidth : window.innerWidth;
        }
    }

    function handleArmrestTouchMove(e) {
        if (!armrestIsDragging || e.touches.length !== 1) return;
        
        armrestCurrentX = e.touches[0].clientX;
        armrestCurrentY = e.touches[0].clientY;
        
        const deltaX = armrestCurrentX - armrestStartX;
        const deltaY = armrestCurrentY - armrestStartY;
        
        // Check if this is a horizontal swipe (more horizontal than vertical)
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            e.preventDefault();
            
            // Visual feedback during drag
            const track = document.getElementById('armrestTrack');
            if (track) {
                // Calculate in pixels - slides are 90% of container + 5% gap
                const containerWidth = window.innerWidth - 32; // Container is 100vw - 32px
                const slideWidth = containerWidth * 0.9; // 90% of container
                const gap = containerWidth * 0.05; // 5% gap
                
                let baseOffset;
                if (armrestCurrentIndex === 2) {
                    // For 3rd video, position after 2nd video
                    const prevSlidesOffset = 2 * (slideWidth + gap);
                    baseOffset = -prevSlidesOffset;
                } else {
                    // Normal offset for first two videos
                    baseOffset = -armrestCurrentIndex * (slideWidth + gap);
                }
                
                const dragOffset = deltaX; // Use raw pixel delta
                track.style.transform = `translateX(${baseOffset + dragOffset}px)`;
            }
        }
    }

    function handleArmrestTouchEnd(e) {
        if (!armrestIsDragging || e.changedTouches.length !== 1) return;
        
        const deltaX = armrestCurrentX - armrestStartX;
        const deltaY = armrestCurrentY - armrestStartY;
        const threshold = armrestContainerWidth * 0.3; // 30% threshold
        
        // Only process if this was primarily a horizontal swipe
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            if (Math.abs(deltaX) > threshold) {
                if (deltaX > 0 && armrestCurrentIndex > 0) {
                    // Swipe right - go to previous
                    prevArmrestVideo();
                } else if (deltaX < 0 && armrestCurrentIndex < 2) {
                    // Swipe left - go to next
                    nextArmrestVideo();
                } else {
                    // At boundary - snap back
                    updateArmrestPosition();
                }
            } else {
                // Didn't meet 30% threshold - snap back
                updateArmrestPosition();
            }
        } else {
            // Vertical swipe - snap back
            updateArmrestPosition();
        }
        
        armrestIsDragging = false;
    }

    function nextArmrestVideo() {
        if (armrestCurrentIndex < 2) {
            armrestCurrentIndex++;
            updateArmrestPosition();
            updateArmrestButtons();
            playCurrentArmrestVideo();
        }
    }

    function prevArmrestVideo() {
        if (armrestCurrentIndex > 0) {
            armrestCurrentIndex--;
            updateArmrestPosition();
            updateArmrestButtons();
            playCurrentArmrestVideo();
        }
    }

    function goToArmrestVideo(index) {
        if (index >= 0 && index <= 2 && index !== armrestCurrentIndex) {
            armrestCurrentIndex = index;
            updateArmrestPosition();
            updateArmrestButtons();
            playCurrentArmrestVideo();
        }
    }

    function updateArmrestPosition() {
        const track = document.getElementById('armrestTrack');
        const container = document.getElementById('armrestCarousel');
        if (track && container) {
            // Calculate in pixels - slides are 90% of container + 5% gap
            const containerWidth = window.innerWidth - 32; // Container is 100vw - 32px
            const slideWidth = containerWidth * 0.9; // 90% of container
            const gap = containerWidth * 0.05; // 5% gap
            
            let offset;
            if (armrestCurrentIndex === 2) {
                // For 3rd video, position it after the 2nd video but centered
                // Calculate offset to position 3rd video centered with no peek
                const prevSlidesOffset = 2 * (slideWidth + gap); // Position after first 2 videos
                offset = prevSlidesOffset;
            } else {
                // Normal offset for first two videos (with peek)
                offset = armrestCurrentIndex * (slideWidth + gap);
            }
            
            track.style.transform = `translateX(-${offset}px)`;
        }
        
        // Update dots
        document.querySelectorAll('.armrest-dot').forEach((dot, i) => {
            dot.classList.toggle('active', i === armrestCurrentIndex);
        });
    }

    function updateArmrestButtons() {
        const prevBtn = document.getElementById('armrestPrevBtn');
        const nextBtn = document.getElementById('armrestNextBtn');
        
        if (prevBtn && nextBtn) {
            // Show/hide back button based on position (only show after leaving first video)
            prevBtn.style.display = armrestCurrentIndex > 0 ? 'flex' : 'none';
            
            // Show/hide next button (hide when at last video)
            nextBtn.style.display = armrestCurrentIndex < 2 ? 'flex' : 'none';
        }
    }

    function playCurrentArmrestVideo() {
        // Pause all armrest videos IN THE CAROUSEL ONLY
        document.querySelectorAll('#armrestCarousel .armrest-video').forEach((video, index) => {
            if (index === armrestCurrentIndex) {
                video.currentTime = 0; // Reset to beginning
                video.play().catch(() => {
                    // Auto-play failed, retry after a short delay
                    setTimeout(() => {
                        video.play().catch(() => {
                            console.log('Auto-play prevented for armrest video', index);
                        });
                    }, 100);
                });
            } else {
                video.pause();
            }
        });
    }

    // Handle video play/pause events
    document.addEventListener('DOMContentLoaded', function() {
        // Initialize armrest carousel
        initArmrestCarousel();
        
        // Made to Fit You video
        const video = document.querySelector('.mobile-product-video');
        const overlay = document.getElementById('mobileVideoPlayOverlay');
        
        if (video && overlay) {
            // Show overlay when video is paused or ended
            video.addEventListener('pause', function() {
                overlay.classList.remove('hidden');
            });
            
            video.addEventListener('ended', function() {
                overlay.classList.remove('hidden');
            });
            
            // Hide overlay when video starts playing
            video.addEventListener('play', function() {
                overlay.classList.add('hidden');
            });
            
            // Handle overlay click
            overlay.addEventListener('click', function() {
                playVideo(video);
            });
        }

        // Awkward Sitting video
        const awkwardVideo = document.querySelector('.mobile-awkward-video');
        const awkwardOverlay = document.getElementById('mobileAwkwardPlayOverlay');
        
        if (awkwardVideo && awkwardOverlay) {
            // Show overlay when video is paused or ended
            awkwardVideo.addEventListener('pause', function() {
                awkwardOverlay.classList.remove('hidden');
            });
            
            awkwardVideo.addEventListener('ended', function() {
                awkwardOverlay.classList.remove('hidden');
            });
            
            // Hide overlay when video starts playing
            awkwardVideo.addEventListener('play', function() {
                awkwardOverlay.classList.add('hidden');
            });
            
            // Handle overlay click
            awkwardOverlay.addEventListener('click', function() {
                playAwkwardVideo(awkwardVideo);
            });
        }

        // Initial OOS state for mobile chair (when default color is sold out)
        var activeMobileSwatch = document.querySelector('.ergonix-wrapper .mobile-color-option.active');
        if (activeMobileSwatch && window.ergonixApplyOOS) {
            var mColor = activeMobileSwatch.dataset.color;
            var mVariantId = activeMobileSwatch.dataset.variantId || (window.productVariants && window.productVariants[mColor]);
            window.ergonixApplyOOS(mColor, mVariantId, '#oos-chair-mobile', '#ergonix-chair-mobile-cta');
        }
    });

    // Expose mobile gallery functions for button onclick handlers
    window.ErgonixMobile = {
        nextImage: nextImage,
        previousImage: previousImage,
        selectImage: selectImage,
        selectMedia: selectMedia,
        changeImage: selectImage,
        goToSlide: goToSlide,
        toggleMute: mobileToggleMute,
        playVideo: playVideo,
        pauseVideo: pauseVideo,
        playAwkwardVideo: playAwkwardVideo,
        pauseAwkwardVideo: pauseAwkwardVideo,
        nextArmrestVideo: nextArmrestVideo,
        prevArmrestVideo: prevArmrestVideo,
        goToArmrestVideo: goToArmrestVideo
    };
})();